/**
 * 创建人：但志强
 * 时间：2019-03-19
 * 描述：公共表格组件 可单选 复选 toolbar
 * 使用说明: 参考 sw-table-tree 配置应用说明文档
 * 更新记录: 
 */
import { Component, OnInit, Input, ContentChild, TemplateRef, Output, EventEmitter, ViewChild, SimpleChanges } from '@angular/core';
import { SwToolbarComponent } from '../sw-toolbar/sw-toolbar.component';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import * as _ from 'lodash';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { SystemIdService } from 'src/app/librarys/serves/public/system-id.service';
declare var $: any;

/**
 * 下拉树表格 sw-table-tree
 */
@Component({
  selector: 'sw-table-tree',
  templateUrl: './sw-table-tree.component.html',
  styleUrls: ['./sw-table-tree.component.css']
})

export class SwTableTreeComponent implements OnInit {
  /**
   * 选中的索引
   * @ignore
   */
  selected: any = {};   

  /**
   * 绑定数组
   * @ignore
   */
  arrItem: any = []; 

  /**
   * 输入表格的数据
   */
  @Input() datas: any[] = []; 

  /**
   * 输出选中的数据
   */
  @Output() selectData = new EventEmitter();
  
   /**
   * 按钮点击事件 返回 functionCode （点击按钮返回code 如： add）
   */
  @Output() operation = new EventEmitter(); 
   /**
   * 按钮点击事件  返回 target （按钮打开方式）
   */
  @Output() openType = new EventEmitter(); 


  /**
   * 自定按钮参数
   *   modalToolBarData: any = [{ status: true, functionCode: 'add', functionName: '新增', icon: 'glyphicon glyphicon-plus', children: [] } ]
   * 
   * status 是否启用 functionCode 按钮code  functionName 按钮显示名称  icon 展示图标  children 二级按钮数据 
   */
  @Input() toolbars: any = []; 

  /**
   * 异步加载uri地址
   */
  @Input() asyncNodeUrl: string;
  /**
   * 通过手动传递uri 获取按钮
   */
  @Input() urlToolBar:string="";  
  /**
   * 主键 用于异步
   */
  @Input() id: string; 

  /**
   * 父主键 用于异步
   */
  @Input() pid: string; 

  /**
   * 是否展开第一节点
   */
  @Input() isOneOpen: boolean 

  /**
   * 表格标题
   */
  @Input() tableHeader: string = '';
  /**
   * 启用关闭工具栏
   */
  @Input() initToolBar: boolean = true;

  /**
   * 表格内容
   * @ignore
   */
  @ContentChild('cell') cellTmpl: TemplateRef<any>; 

  /**
   * 第一列单元格
   * @ignore
   */
  @ContentChild('filed') filedTmpl: TemplateRef<any>; 

  /**
   * 按钮组件
   * @ignore
   */
  @ViewChild("toolbar") toolbar: SwToolbarComponent;  

   /**
   * 表格中表头和表格td中字体居中、居左、居右的class值
   */
  @Input() textClass: string = 'left';

   /**
   * 是否有统计按钮
   */
  @Input() isStatistic: boolean = false
   /**
   * 子按钮下拉的最大高度
   */
  @Input() dropMaxHeight: string = '140px';
    /**
   * toolbar最小高度
   */
  @Input() minHeight: string = '40px'

  /**
   * @ignore
   * @param jwt 获取缓存 
   * @param http  http请求
   * @param box  提示框
   */
  constructor(private jwt: SwJwtService, private http: SwHttpClientService,private box :SwMassageBoxService,private system: SystemIdService,) { }
  
  /**
   * @ignore
   * 系统id
   */
  systemId = this.system.getSystemId()
   /**
   * 表格列表是否显示筛选功能
   * @ignore
   */
  @Input() isFilter: Boolean = false
   /**
   * 表格列表筛选checkbox判断
   * @ignore
   */
  @Input() filterDatas: any = {}
   /**
   * 表格列表筛选dropdown数据
   * @ignore
   */
  @Input() filterDatasArray: any = []

  /**
   * 抛出筛选后数据
   */
  @Output() filter = new EventEmitter();

    /**
   * 是否显示列表 宫格
   * @ignore
   */
  @Input() isDisplay: Boolean = true


  /**
   * 是否为空数据
   */
  isEmpty: boolean = false;

  /**
   * 是否正在加载中
   */
  @Input() isLoading: boolean = false;
 /**
   *系统配置按钮是否显示右边
   */
  @Input() isDefaultRight: boolean = false
 

  /**
   * @ignore
   */
  ngOnInit() {
    this.location();
  }

  /**
   * 初始化数据 
   */
  location() {
    //判断是不是通过url异步加载
    if (this.asyncNodeUrl) {
      //第一次默认加载根节点 默认获取根节点为0
      let str = `{"entity":{"${this.pid}":"0", "systemId": "${this.systemId}"}}`
      let params = JSON.parse(str);
      //然后获取根节点
      this.http.Post(this.asyncNodeUrl, params).subscribe(data => {
        //判断是不是展开第一节点
        if(data["code"]==200){
          this.arrItem =[];
          if (this.isOneOpen) {
            data["data"]["records"].forEach(dt => {
              //如果是默认展开下级 在往下查一级数据
              let str = `{"entity":{"${this.pid}":"${data["data"]["records"][0][this.id]}", "systemId": "${this.systemId}"}}`;
              let params = JSON.parse(str);
              //获取下级节点数据
              this.http.Post(this.asyncNodeUrl, params).subscribe(el => {
                //编写主节点数据 
                dt.level = 1;
                dt.extended = this.isOneOpen;
                this.arrItem.push(dt); //按顺序添加到绑定数组
                el["data"]["records"].forEach(x => {
                  //添加二级节点数据
                  x.level = 2;
                  x.extended = false;
                  this.arrItem.push(x); //按顺序添加到绑定数组
                })
              })
            })
          } else {
            //部展开下级 ，添加根节点数据
            data["data"]["records"].forEach(dt => {
              dt.level = 1;
              dt.extended = false;
              this.arrItem.push(dt); //按顺序添加到绑定数组
            })
          }
        }else{
          this.box.danger("获取数据失败")
        }
      })
    }
  }

  /**
   * @ignore
   */
  ngOnChanges(changes: SimpleChanges) {
    //判断传入的数据
    let datasLength = 0
    let datas1= []
    let datasLength1 = 0
    if(changes && changes['datas']) {
      if(changes['datas']['currentValue']){
        datas1 = [...changes['datas']['currentValue']]
      }
      datasLength1 = datas1.length;
      if(changes['datas']['previousValue'] == undefined) {
        this.isEmpty = false; 
        if(!changes['datas']['firstChange']){
          this.isEmpty = true;
        }
      }else {
        if(datasLength1 > 0) {
          this.isEmpty = false;
        }else {
          this.isEmpty = true;
        }
      }
     }
    if (this.datas && this.datas.length > 0) {
      let level = 1;  //节点级数
      this.arrItem = [];  //重置绑定树组
      let temp = _.cloneDeep(this.datas);
      let item = this.isRootTree(temp); //找出根节点
      for (let i of item) {
        i.level = level;  //第1级
        if(this.isOneOpen){
          i.extended = true;  //展开第一级
        }else {
          i.extended = false;  //不展开第一级
        }
        this.arrItem.push(i); //按顺序添加到绑定数组
        this.toDatabase(i[this.id], level); //按顺序添加子级到平级数组里
      }
      
    } else {
      this.arrItem = []
    }
  }

  /**
   * 格式化传入的数据
   * @param pid fujiid
   * @param level  当前级别
   * @ignore
   */ 
  toDatabase(pid: string, level: number) {
    level++;  //级数加1
    let item = this.datas.filter(x => x[this.pid] == pid);  //寻找子节点
    if (item.length == 0) { //没有这将值设为叶；
      this.arrItem[this.arrItem.length - 1].leaf = true;  //当前节点
    }
    for (let i of item) {
      i.level = level;  //
      i.extended = false; //默认不展开
      this.arrItem.push(i);
      this.toDatabase(i[this.id], level)  //递归添加
    }
  }

  /**
   * 判断是否显示出下级数据
   * @param pid  父级id
   * @ignore
   */
  isExtendNode(pid: string) {  //判断是否显示该行
    let item = this.arrItem.find(x => x[this.id] == pid); //寻找父级
    if (item) {
      if (item.extended == true)  //父级展开则显示
        return true;
      else
        return false; //不显示
    }
    return true;
  }

  /**
   * 获取根节点
   * @param dt  节点数据
   * @ignore
   */
  isRootTree(dt) {
    let rootList: any = [];
    dt.forEach(e => {
      let list = dt.filter(x => x[this.id] == e[this.pid]);
      if (list.length == 0) {
        rootList.push(e);
      }
    });
    return rootList;
  }

  /**
   * 点击加载下级数据
   * @param data  节点数据
   * @ignore
   */
  onExtendNode(data: any) { //展开收缩
    //判断是否为异步加载
    if (this.asyncNodeUrl) {
      //判断下级数据是否以及加载出来 ，如果加载出来 直接展开
      if (this.arrItem.filter(x => x[this.pid] == data[this.id]).length <= 0) {
        let str = `{"entity":{"${this.pid}":"${data[this.id]}", "systemId": "${this.systemId}"}}`;
        let params = JSON.parse(str);
        //获取下级数据
        this.http.Post(this.asyncNodeUrl, params).subscribe(el => {
          //设置为展开
          data.extended = true;
          //当前点击的下标
          let i = this.arrItem.indexOf(data);
          //用作插入下标
          let j = 0;
          //判断下级是否有数据，没有数据隐藏展开图标
          if (el["data"]["records"] == null || el["data"]["records"] == undefined || el["data"]["records"].length == 0) {
            data.leaf = true;
          }
          //然后将数据插入到数据中
          el["data"]["records"].forEach(dt => {
            dt.level = data.level + 1;
            dt.extended = false;
            if (i >= 0) {
              j++;
              this.arrItem.splice(i + j, 0, dt)
            }
          })

        })
      }
    }

    if (data.extended) {  //展开就折叠操作
      data.extended = false;
      this.toExtendNode(data[this.id]); //将子节点依次折叠
    }
    else {
      data.extended = true;
    }
  }
  /**
   * 加载下级节点
   * @param id 节点id
   * @ignore
   */
  toExtendNode(id) {
    let item = this.arrItem.filter(x => x[this.pid] == id);
    for (let i of item) {
      i.extended = false;
      this.toExtendNode(i[this.id]);
    }
  }

  /**
   * 点击选中事件
   * @param data 选中节点数据
   * @ignore
   */
  onClickSelectTree(data: any) {
    if(data["id"] == this.selected["id"]){
      //如果是点击选中项,就取消选中
      this.selected = {};
      this.selectData.emit(this.selected);
    } else {
      //如果点击的是之前没有选中的,就选中此项
      this.selected = data;
      this.selectData.emit(data);
    }
  }

  /**
   * 清空
   * @ignore
   */
  clearselect() {
    this.selected = {};
  }

  /**
   * 禁用按钮
   * @param type  传入all 禁用全部按钮 
   */
  disableToolbar(type: string) {
    if (type !== "all")
      this.toolbar.toolbarDisable(type);
    else
      this.toolbar.toolbarAllDisable();
  }
  /**
   * 启用按钮
   * @param type 传入all 启用全部按钮 
   */
  enableToobar(type: string) {
    if (type !== "all")
      this.toolbar.toolbarEnable(type);
    else
      this.toolbar.toolbarAllEnable();
  }

}
